__turbopack_context__.v({
  "container": "styles-module-scss-module__q3sLkW__container",
  "divider": "styles-module-scss-module__q3sLkW__divider",
  "form_success": "styles-module-scss-module__q3sLkW__form_success",
  "header": "styles-module-scss-module__q3sLkW__header",
  "left": "styles-module-scss-module__q3sLkW__left",
  "right": "styles-module-scss-module__q3sLkW__right",
  "row": "styles-module-scss-module__q3sLkW__row",
  "subheader": "styles-module-scss-module__q3sLkW__subheader",
  "top": "styles-module-scss-module__q3sLkW__top",
});
